import { render } from "./dropped.vue?vue&type=template&id=791507e1&scoped=true"
import script from "./dropped.vue?vue&type=script&lang=js"
export * from "./dropped.vue?vue&type=script&lang=js"

import "./dropped.vue?vue&type=style&index=0&id=791507e1&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791507e1"]])

export default __exports__